import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { CareerServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Career Master section
 */
const useListCareer = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["career-list", page_no], CareerServices.careerList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddCareer = (onSuccess, onError = onDefaultError) => {
  return useMutation(CareerServices.addCareer, {
    onSuccess,
    onError,
  });
};
const useUpdateCareer = (onSuccess, onError = onDefaultError) => {
  return useMutation(CareerServices.updateCareer, {
    onSuccess,
    onError,
  });
};
const useViewCareer = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("career-view", () => CareerServices.viewCareer({ id }), {
    onSuccess,
    onError,
  });
};
const useCareerDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(CareerServices.deleteCareer, {
    onSuccess,
    onError,
  });
};
const useCareerStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(CareerServices.updateStatusCareer, {
    onSuccess,
    onError,
  });
};
const useCareerfileDownload = (filename,onSuccess, onError = onDefaultError) => {
  
  return useQuery("career-donwload", () => CareerServices.fileDownload(filename), {
    onSuccess,
    onError,
  });
};


export {
  useListCareer,
  useCareerStatusChange,
  useAddCareer,
  useUpdateCareer,
  useViewCareer,
  useCareerDelete,
  useCareerfileDownload
};
